import axios from 'axios';
import { getAuthorizationHeader } from 'helpers/auth.cuboh';
import { CORE_API_TIMEOUT_MS } from 'constants/cuboh';

export async function createCoreAxiosInstance() {
  return axios.create({
    baseURL: import.meta.env.VITE_CUBOH_CORE_SERVER_URL,
    timeout: CORE_API_TIMEOUT_MS,
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json',
      Authorization: getAuthorizationHeader(),
    },
  });
}

export async function createMenuMappingV2AxiosInstance() {
  return axios.create({
    baseURL: import.meta.env.VITE_MENU_MAPPING_V2_URL,
    headers: {
      'Content-Type': 'application/json',
      Authorization: getAuthorizationHeader(),
    },
  });
}

export async function createReportAxiosInstance() {
  return axios.create({
    baseURL: import.meta.env.VITE_CUBOH_CUBEJS_URL,
    headers: {
      'Content-Type': 'application/json',
      Authorization: getAuthorizationHeader(),
    },
  });
}

export async function createMenuManagementAxiosInstance(contentType = 'application/json') {
  return axios.create({
    baseURL: import.meta.env.VITE_CUBOH_MENU_MANAGEMENT_URL,
    headers: {
      Accept: 'application/json',
      'Content-Type': contentType,
      Authorization: getAuthorizationHeader(),
    },
  });
}

export async function createOrchestratorAxiosInstance() {
  return axios.create({
    baseURL: import.meta.env.VITE_CUBOH_ORCHESTRATOR_URL,
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json',
      'X-Api-Key': import.meta.env.VITE_CUBOH_ORCHESTRATOR_KEY,
      stage: import.meta.env.VITE_CUBOH_WS_STAGE,
    },
  });
}

export async function createAssetAxiosInstance() {
  return axios.create({
    baseURL: import.meta.env.VITE_CUBOH_ASSET_URL,
    headers: {},
  });
}

export async function createCountryStateCityAxiosInstance() {
  return axios.create({
    baseURL: import.meta.env.VITE_CUBOH_COUNTRY_STATE_CITY_URL,
    headers: {
      'X-CSCAPI-KEY': import.meta.env.VITE_CUBOH_COUNTRY_STATE_CITY_API_KEY,
    },
  });
}
